"use strict";

import module from "./module";
import "./details.spec";

export default module;
